export const ERROR_CODES = {
  BATCH_LIMIT_EXCEEDED: "BATCH_LIMIT_EXCEEDED",
  UNSUPPORTED_FILE_TYPE: "UNSUPPORTED_FILE_TYPE",
  FILE_TOO_LARGE: "FILE_TOO_LARGE",
  EMPTY_FILE: "EMPTY_FILE",
  TOO_MANY_PAGES: "TOO_MANY_PAGES",
  DUPLICATE: "DOCUMENT_ALREADY_EXISTS",
  UPLOAD_FAILED: "UPLOAD_FAILED",
} as const;

export type ErrorCode = (typeof ERROR_CODES)[keyof typeof ERROR_CODES];

export const ERROR_CODE_VALUES: readonly ErrorCode[] =
  Object.values(ERROR_CODES);

export const isErrorCode = (value: string): value is ErrorCode =>
  ERROR_CODE_VALUES.includes(value as ErrorCode);
